
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/machine-identity",
      function () {
        return require("private-next-pages/solutions/machine-identity.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/machine-identity"])
      });
    }
  